// Currency formatting utilities for Indian number system
export const formatIndianCurrency = (value: number): string => {
  // Format number using Indian number system (1,00,000 format)
  const formattedValue = value.toLocaleString('en-IN', { 
    minimumFractionDigits: 2, 
    maximumFractionDigits: 2 
  });
  
  return `₹${formattedValue}`;
}; 